/**
 * Save value to local storage.
 * @param key Key to save value under.
 * @param value Value to save.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const saveToLocalStorage = (key: string, value: any) => localStorage.setItem(key, JSON.stringify(value));

/**
 * Get value from local storage.
 * @param key Key to get value for.
 */
export const getFromLocalStorage = (key: string) => {
	const value = localStorage.getItem(key);
	return value ? JSON.parse(value) : null;
};
